
<app-loading-spinner *ngIf="loading; else not_loading"></app-loading-spinner>
<ng-template #not_loading>
  <div class="d-flex align-items-center mb-4">
    <h2>Certificates for: </h2>
    <select class="form-control ml-3" style="width: fit-content" [(ngModel)]="this.selectedCourseCode" (ngModelChange)="getCompletedUnits()">
        <option *ngFor="let course of selectableCourses" [ngValue]="course.Code">
            {{ course.Description }}
        </option>
    </select>
  </div>

  <div *ngIf="!selectedCourseCompletedUnits || selectedCourseCompletedUnits.length === 0">
    <div class="no-certificates-message">Student currently has no certificates to display.</div>
  </div>
  <div class="container">
    <div class="certificate-grid">
      <div class="certificate-container" *ngFor="let certificate of courseCompleteCertificate">
        <app-certificate-renderer [template]="certificate"></app-certificate-renderer>
      </div>
      <div class=certificate-container *ngFor="let unit of selectedCourseCompletedUnits">
        <app-certificate-renderer [template]="generateUnitCertificate(getCourseNumber(), unit.UnitNumber, unit.LastActivityCompletion)"></app-certificate-renderer>
      </div>
    </div>
  </div>
</ng-template>


